import { Permissions } from 'powerbi-models';
import * as pbi from 'powerbi-client';
import { IReportEmbedConfiguration } from 'embed';

export const POWER_BI_REPORT_EMBED_URL = 'https://app.powerbi.com/reportEmbed?reportId=';

export function createConfig(token, reportId): IReportEmbedConfiguration {
  return {
    type: 'report',
    tokenType: pbi.models.TokenType.Aad,
    accessToken: token || 'nullable_token',
    embedUrl: POWER_BI_REPORT_EMBED_URL + reportId,
    permissions: Permissions.Copy,
    settings: {
      bars: { actionBar: { visible: true } },
      panes: {
        filters: { visible: false },
        selection: { visible: false },
        bookmarks: { visible: false },
        fields: { visible: false },
        syncSlicers: { visible: false },
        visualizations: { visible: false },
      },
    },
  };
}
